import { Converter } from '../types/converter';

export const specificVolumeConverter: Converter = {
  id: 'specificVolume',
  name: 'Specific Volume Converter',
  icon: 'Box',
  categories: ['engineering'],
  units: [
    // Base SI unit
    { name: 'Cubic meter/kilogram', symbol: 'm³/kg', factor: 1 },
    
    // Metric units
    { name: 'Cubic centimeter/gram', symbol: 'cm³/g', factor: 1 },  // Same as m³/kg
    { name: 'Liter/kilogram', symbol: 'L/kg', factor: 0.001 },
    { name: 'Liter/gram', symbol: 'L/g', factor: 1 },
    
    // Imperial/US units
    { name: 'Cubic foot/kilogram', symbol: 'ft³/kg', factor: 0.062427960576145 },
    { name: 'Cubic foot/pound', symbol: 'ft³/lb', factor: 0.062427960576145 * 0.45359237 },
    { name: 'Gallon (US)/pound', symbol: 'gal (US)/lb', factor: 0.120095042816365 },
    { name: 'Gallon (UK)/pound', symbol: 'gal (UK)/lb', factor: 0.099776372663771 }
  ]
};
